/* gia-rings-cert-selector: title / description / gallery swap per selected variant.
   No-op unless <product-info> carries data-cert-swap (products with a "Certificate" option).
   Media rule (John): the main picture is always the ring; a certificate shows LAST among the
   images (before any video) and only for the selected lab - the gallery is re-rendered from the
   fetched section, never re-ordered around the certificate. */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var data = event && event.data ? event.data : {};
    var sectionId = data.sectionId, html = data.html, variant = data.variant;
    var info = document.getElementById('MainProduct-' + sectionId);
    if (!info || !info.hasAttribute('data-cert-swap') || !variant || !html) return;
    var copy = function (sel) {
      var a = html.querySelector(sel), b = info.querySelector(sel);
      if (a && b) b.innerHTML = a.innerHTML;
    };
    var oldTitle = (info.querySelector('.product__title h1') || {}).textContent || '';
    copy('#ProductTitle-' + sectionId);
    copy('#ProductTitleLink-' + sectionId);
    copy('#ProductDescription-' + sectionId);
    var newTitle = (info.querySelector('.product__title h1') || {}).textContent || '';
    if (oldTitle.trim() && newTitle.trim() && oldTitle.trim() !== newTitle.trim()) {
      document.title = document.title.replace(oldTitle.trim(), newTitle.trim());
    }
    /* gallery: swap in the server-rendered one (ring photo first and active, certificate of the
       selected lab at its own position, other certificates hidden, thumbnails to match) */
    var oldGallery = info.querySelector('media-gallery');
    var newGallery = html.querySelector('media-gallery');
    if (oldGallery && newGallery) {
      oldGallery.replaceWith(document.importNode(newGallery, true));
      if (info.hasAttribute('data-zoom-on-hover') && typeof enableZoomOnHover === 'function') {
        try { enableZoomOnHover(2); } catch (e) {}
      }
    }
    var oldModal = document.querySelector('product-modal .product-media-modal__content');
    var newModal = html.querySelector('product-modal .product-media-modal__content');
    if (oldModal && newModal) oldModal.innerHTML = newModal.innerHTML;
    var dpo = document.getElementById('itoris_dynamicproductoptions');
    if (dpo && window.dpoOptions && typeof window.dpoOptions.updatePrice === 'function') {
      try { dpo.dpoProductInitialPrices = false; window.dpoOptions.updatePrice(true); } catch (e) {}
    }
  });
})();
